import { TSubscriberHandler } from '@cian/events-log';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { consumeUser } from '../eventsLogs/consumers';
import { createAuthenticationEventHandler } from '../eventsLogs/handlers';
import { selectUser } from '../selectors/user';
import { TReduxStore } from '../types/redux';

interface IParameters {
  reduxStore: TReduxStore;
}

let unsubscribe: VoidFunction | undefined;

export function useAuthenticationSubscription({ reduxStore }: IParameters) {
  const { isAuthenticated } = useSelector(selectUser);

  React.useEffect(() => {
    if (isAuthenticated) {
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = undefined;
      }

      return;
    }

    if (!unsubscribe && !isAuthenticated) {
      const authenticationEventHandler = createAuthenticationEventHandler({ reduxStore });
      unsubscribe = consumeUser(authenticationEventHandler as TSubscriberHandler);
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = undefined;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
}
